/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import "./src/globals.css";

import { config } from "@fortawesome/fontawesome-svg-core";
import React from "react";
import AdminLayout from "./src/components/admin/admin-layout/AdminLayout";
import Layout from "./src/components/layout";
import UIToolsProvider from "./src/contexts/UIToolsProvider";
import { LanguageProvider } from "./src/contexts/LanguageContext";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "animate.css/animate.min.css";

import { QueryClientProvider } from "@tanstack/react-query";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import AdminPrivateRoute from "./src/components/auth/AdminPrivateRoute";
import AuthProvider from "./src/contexts/AuthProvider";
import { queryClient } from "./src/queryClient";


export function onClientEntry() {
	/* Prevents fontawesome auto css insertion */
	config.autoAddCss = false;
	axios.defaults.baseURL = process.env.GATSBY_API_URL;
	axios.interceptors.request.use((config) => {
		const token = localStorage.getItem("auth_token");
		config.headers.Authorization = token ? `Bearer ${token}` : "";
		return config;
	});
}

export function wrapPageElement({ element, props }) {
	// props provide same data to Layout as Page element will get
	// including location, data, etc - you don't need to pass it
	return (
		<AuthProvider>
			<UIToolsProvider>
				<ToastContainer position="bottom-right" />
				{props.location.pathname.indexOf("/admin") === 0 ? (
					<AdminPrivateRoute>
						<AdminLayout>{element}</AdminLayout>
					</AdminPrivateRoute>
				) : (
					<Layout {...props}>{element}</Layout>
				)}
			</UIToolsProvider>
		</AuthProvider>
	);
}

export const wrapRootElement = ({ element }) => (
	<QueryClientProvider client={queryClient}>
		<LanguageProvider>{element}</LanguageProvider>
	</QueryClientProvider>
);